import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Mail, Menu, X } from 'lucide-react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navigation = [
    { name: 'Home', hashLink: 'home' },
    { name: 'About', hashLink: 'about' },
    { name: 'Contact Us', hashLink: 'contact-us' },
  ];

  const isActive = (path) => location.pathname === path;

  const scrollTo = (section) => {
    document.getElementById(section)?.scrollIntoView({behavior: 'smooth'})
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-md border-b border-border-light shadow-sm">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2">
            <img src='/assets/vwhorselogo.png' width="60px" height="60px" />
            <span className="heading-5 text-text-primary">VWH</span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-1">
            {navigation.map((item) => (
              <button
                key={item.name}
                onClick={() => scrollTo(`${item.hashLink}`)}
                className={`nav-link px-4 py-2 rounded-lg transition-all ${
                  isActive(item.href) 
                    ? 'text-secondary-trust bg-bg-accent border border-secondary-trust/20' 
                    : 'text-text-secondary hover:text-text-primary hover:bg-bg-accent'
                }`}
              >
                {item.name}
              </button>
            ))}
            <a
              href="mailto:sales@whitehorses.co.in"
              className="btn-primary"
            >
              <Mail className="text-brand-primary mt-1 flex-shrink-0" size={20} /> &nbsp; sales@whitehorses.co.in
            </a>
          </nav>

          {/* Mobile menu button */}
          <button
            className="md:hidden p-2 text-text-primary hover:text-secondary-trust rounded-lg hover:bg-bg-accent transition-all"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden border-t border-border-light py-4 bg-white/95 backdrop-blur-md">
            <nav className="flex flex-col space-y-2">
              {navigation.map((item) => (
                <button
                  key={item.name}
                  onClick={() => scrollTo(`${item.hashLink}`)}
                  className={`nav-link px-4 py-2 rounded-lg transition-all ${
                    isActive(item.href) 
                      ? 'text-secondary-trust bg-bg-accent border border-secondary-trust/20' 
                      : 'text-text-secondary hover:text-text-primary hover:bg-bg-accent'
                  }`}
                >
                  {item.name}
                </button>
              ))}
              <a
                href="mailto:sales@whitehorses.co.in"
                className="btn-primary"
              >
                <Mail className="text-brand-primary mt-1 flex-shrink-0" size={20} /> &nbsp; sales@whitehorses.co.in
              </a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;